import { render, staticRenderFns } from "./CustomerNotificationWizardNav.vue?vue&type=template&id=36f1c38c&"
import script from "./CustomerNotificationWizardNav.vue?vue&type=script&lang=js&"
export * from "./CustomerNotificationWizardNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports